var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningTriangle = function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4.5,
    y: 4,
    fill: "#FEF0C7",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DC6803",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.5 24v4m0 4h.01m-1.72-13.14L18.32 33a1.998 1.998 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3l-8.47-14.14a2.001 2.001 0 0 0-3.42 0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4.5,
    y: 4,
    stroke: "#FFFAEB",
    strokeWidth: 8,
    rx: 24
  })));
};
export default SvgWarningTriangle;